"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArrayLikeObject = _interopRequireDefault(require("lodash/isArrayLikeObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _reactRedux = require("react-redux");
var _ssrWindow = require("ssr-window");
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Portal extends _react.PureComponent {
  static defaultProps = {
    appendTo: _ssrWindow.document.body
  };
  constructor(props) {
    super(props);
    const {
      className,
      appendTo
    } = props;
    this._EL = _ssrWindow.document.createElement('div');
    this._ROOT = (0, _isString.default)(appendTo) ? _dom.default.el(appendTo) : appendTo;
    if ((0, _isArrayLikeObject.default)(this._ROOT)) {
      this._ROOT = this._ROOT[0];
    }
    if (className) {
      _dom.default.addClass(this._EL, className);
    }
  }
  componentDidMount() {
    this._ROOT.appendChild(this._EL);
  }
  componentWillUnmount() {
    this._ROOT.removeChild(this._EL);
  }
  render() {
    const {
      store,
      children
    } = this.props;
    if (store) {
      return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, children), this._EL);
    } else {
      return /*#__PURE__*/(0, _reactDom.createPortal)(children, this._EL);
    }
  }
}
exports.default = Portal;